'use client';
import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen bg-white text-[#0f172a]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#1a56ff] mb-8 transition-colors">
          <ArrowLeft size={16} /> Back to Home
        </Link>
        <h1 className="text-3xl sm:text-4xl font-bold mb-2">Refund Policy</h1>
        <p className="text-xs text-slate-400 mb-10">Last updated: January 2026</p>
        <div className="space-y-8 text-sm text-slate-600 leading-relaxed">
          <section>
            <h2 className="text-base font-bold text-[#0f172a] mb-3">Registration Fee</h2>
            <p>The one-time ₹4,999 registration fee is <strong>non-refundable</strong> once your account has been activated and you have accessed the agent dashboard or training materials. This is because digital access is granted immediately upon payment.</p>
          </section>
          <section>
            <h2 className="text-base font-bold text-[#0f172a] mb-3">Order Payments</h2>
            <p>Payments made for service orders (Website Development, Press Release, Business Compliance) are non-refundable once the order has been accepted and work has commenced. If an order cannot be fulfilled due to reasons on our end, a full refund will be issued.</p>
          </section>
          <section>
            <h2 className="text-base font-bold text-[#0f172a] mb-3">Exceptional Circumstances</h2>
            <p>In exceptional cases where a refund may be warranted (e.g., duplicate payment, technical error), please contact us within 7 days of the transaction at <a href="mailto:support@dropservice.in" className="text-[#1a56ff] hover:underline">support@dropservice.in</a>. Each case will be reviewed individually.</p>
          </section>
          <section>
            <h2 className="text-base font-bold text-[#0f172a] mb-3">Wallet Balance</h2>
            <p>Earned commissions in your wallet can be withdrawn to your bank account. Wallet balances are not refundable as cash in cases of account termination due to policy violations.</p>
          </section>
          <section>
            <h2 className="text-base font-bold text-[#0f172a] mb-3">Contact</h2>
            <p>For refund-related queries, contact us at <a href="mailto:support@dropservice.in" className="text-[#1a56ff] hover:underline">support@dropservice.in</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
